module.exports = __webpack_public_path__ + "img/image-02.3ce9e661.jpeg";